import React from 'react'
import {hero} from "../../assets";

function Hero() {
  return (
    <section id='hero' className='background-black'>
      <div className="container">
        <div className='row justify-content-center align-items-center' data-aos="zoom-in" data-aos-duration="1000">
          <div className="hero_left col-lg-6 col-12 pe-xl-5 px-4 px-md-2">
            <h1 className='mb-4 color-secondary'>Sewa Mobil Murah dan Berkualitas Palu</h1>
            <p className='text-light'>Anda butuh kendaraan untuk berkeliling kota ataupun perjalanan jauh ? Sewa mobil dengan <span className='fw-bold'>Black Canyon Transport ! </span> Rental mobil termurah dan berkualitas di kota Palu, Dapatkan mobil berkualitas dengan harga yang terjangkau dan terpercaya.</p>
          </div>
          <div className="hero_right col-lg-6 col-12 ">
            <img src={hero} alt="hero_image" width="100%" height="100%" style={{objectFit: "cover"}} />
          </div>
        </div>
        <div className="custom-shape-divider-bottom-1676267551">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Hero